import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import ActionChoiceCardDetails from './ActionChoiceCardDetails';
import FindLocalRep from '../LocalRep/FindLocalRep';

const ActionChoiceCard = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.key} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/actionChoiceCard"
                            name="ActionChoiceCard"
                            exact
                            component={ActionChoiceCardDetails}
                        />
                        <Route
                            path="/actionChoiceCard/findRep"
                            name="ActionChoiceCardFindMultiRep"
                            exact
                            component={FindLocalRep}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default ActionChoiceCard;
